import * as React from 'react';
import { cn } from '@/lib/utils';
export function FreeStatusbar({className,...props}:React.HTMLAttributes<HTMLDivElement>){return <div data-slot="freeui-statusbar" role="status" className={cn('freeui-statusbar',className)} {...props}/>;}
export function FreeStatusbarItem({className,...props}:React.HTMLAttributes<HTMLSpanElement>){return <span className={cn('freeui-statusbar-item',className)} {...props}/>;}
